import { combineReducers } from 'redux'
import { 
    messages, 
    firewalld,
    settings,
} from './reducers'

export default combineReducers({
    messages,
    firewalld,
    settings,
})



// WEBPACK FOOTER //
// ./src/reducers/masterReducer.js